"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var caches_1 = require("ayvri-services/lib/caches");
var user_geoservice_1 = require("ayvri-services/lib/user-geoservice");
var fn_1 = require("ayvri-std/lib/fn");
var kDefaultCurrency = 'EUR';
var kDefaultUnits = 'metric';
var FailoverGeolocationService = /** @class */ (function () {
    function FailoverGeolocationService() {
    }
    FailoverGeolocationService.prototype.getCurrency = function () {
        return Promise.resolve(kDefaultCurrency);
    };
    FailoverGeolocationService.prototype.getUnits = function () {
        return Promise.resolve(kDefaultUnits);
    };
    return FailoverGeolocationService;
}());
exports.userGeo = fn_1.memoize(function () {
    if (window && hasIPDataKey(window)) {
        return new user_geoservice_1.UserGeo(window.__ip_data_key, { fetch: window.fetch.bind(window) }, caches_1.tryMakeLocalStorageCache());
    }
    console.warn('ipdata key is not defined. Using failover Geolocation service.');
    return new FailoverGeolocationService();
});
function hasIPDataKey(obj) {
    return typeof obj.__ip_data_key === 'string';
}
